<template>
    <div class="stripe-billing-management">
        <div class="row pb-2">
            <h5 class="col-6 font-weight-bolder">{{ $t('manage_your_cards') }}</h5> 
        </div>
        <div v-show="paymentMethodsLoadStatus == 2 && paymentMethods.length == 0" class="row pl-4">
            {{ $t('no_payment_method_on_file') }}
        </div>
        <div class="font-weight-bolder font py-2">{{ $t('add_card_details') }}</div>
        <div id="card-element" class="py-5"></div>

        <div class="pb-1 pt-3 d-flex justify-content-end">
            <button class="btn btn-primary " id="add-card-button" v-on:click="submitPaymentMethod()">{{ $t('save_card_details') }}</button>
        </div> 
        
        <div class="font-weight-bolder font py-3" v-show="paymentMethodsLoadStatus == 2 && paymentMethods.length > 0 && !noBankAccount">{{ $t('your_cards') }}</div>
        <div class="py-3 mx-3">
            <div v-show="paymentMethodsLoadStatus == 2 && paymentMethods.length > 0">
                <div v-for="(method, key) in paymentMethods" :key="key">
                    <div v-if="method.type != 'bank_account'"
                     v-bind:key="'method-'+key"
                     v-on:click="paymentMethodSelected = method.id"
                     class="border row p-1 mt-2"
                     >
                        <!-- <div class="col-2 py-2">
                            <template v-if="method.brand">
                                {{ method.brand.charAt(0).toUpperCase() }}{{ method.brand.slice(1) }}
                            </template>
                        </div> -->
                        <div class="col-9 py-2 text-left">
                            <span class="fa fa-credit-card"></span>
                            <span v-if="method.brand">{{ capitalizeString(method.brand) }}</span> ************{{ method.last_four }}
                             {{ $t('expires_abbreviation') }}: {{ method.exp_month }} / {{ method.exp_year }}
                            <!-- Ending In: {{ method.last_four }} Exp: {{ method.exp_month }} / {{ method.exp_year }} -->
                        </div>
                        <div class="col-3 text-right pr-0">
                            <span v-on:click.stop="removePaymentMethod( method.id )"><a href="javascript:;" class="btn btn-danger btn-sm"><i class="kt-nav__link-icon flaticon2-trash"></i></a></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="paymentMethodsLoadStatus == 2 && paymentMethods.length > 0" class="separator separator-solid my-5"></div>

    </div>
</template>
<script>
    import CustomerAPIService from '@/js/api/customers/customers';
    import UserAPIService from '@/js/api/users/users';
    export default {
        props: ['customerId', 'customerType', 'CONNECTED_STRIPE_ACCOUNT_ID'],
        data(){
            return {
                stripeAPIToken: import.meta.env.VITE_STRIPE_BILLING_API_KEY,
                intentToken: '',
                stripe: '',
                elements: '',
                card: '',
                name: '',
                email: '',
                addPaymentStatus: 0,
                addPaymentStatusError: '',
                paymentMethods: [],
                paymentMethodsLoadStatus: 0,
                paymentMethodSelected: {},
                isBankAccount: false
            }
        },
        mounted(){

            this.includeStripe('js.stripe.com/v3/', function(){
                this.configureStripe();
            }.bind(this) );

            this.getAccountDetail();
            this.loadIntent(); 
            this.loadPaymentMethods();
            this.validateInput();
        },
        computed: {
            noBankAccount: function(){
                if(this.isBankAccount == true){
                    return this.isBankAccount;
                }
            }
        },
        methods: {
            /*
                Includes Stripe.js dynamically
            */
            includeStripe( URL, callback ){
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];

                object.setAttribute('defer', 'defer'); // check if it required.
                object.src = '//' + URL;
                if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },

            /*
                Configures Stripe by setting up the elements and
                creating the card element.
            */
            configureStripe(){
                
                // Set the connected Stripe Account on which the PaymentMethod should be created
                this.stripe = Stripe(this.stripeAPIToken, { stripeAccount: this.CONNECTED_STRIPE_ACCOUNT_ID});

                this.elements = this.stripe.elements();
                this.card = this.elements.create('card');
                this.card.mount('#card-element');
            },
            /*
                Loads the payment intent key for the user to pay.
            */
            loadIntent(){
                CustomerAPIService.getStripeBillingIntent(this.customerId, this.customerType, this.access_token)
                    .then((response) => {
                        this.intentToken = response.data;
                    }).catch((error) => {
                        this.notify("Error Exception!","Error", "error");
                    });
            },

            submitPaymentMethod(){
                this.$store.commit('SHOW_LOADER',true);
                this.addPaymentStatus = 1;
                this.stripe.confirmCardSetup(
                    this.intentToken.client_secret, {
                        payment_method: {
                            card: this.card,

                            billing_details: {
                                name: this.name,
                                email: this.email 
                            }
                        }
                    }
                ).then(function(result) {
                    if (result.error) {
                        this.$store.commit('SHOW_LOADER',false);
                        this.addPaymentStatus = 3;
                        this.addPaymentStatusError = result.error.message;
                        this.notify("Error!", this.addPaymentStatusError, "error");
                    } else {
                        this.savePaymentMethod( result.setupIntent.payment_method );
                        this.addPaymentStatus = 2;
                        this.card.clear();
                        this.$store.commit('SHOW_LOADER',false);
                        this.loadIntent();
                        swal.fire("Success!", "Stripe card added successfully.", "success");
                    }
                }.bind(this));
            },
            /*
                Saves the payment method for the user and
                re-loads the payment methods.
            */
            savePaymentMethod( method ){

                let data = {
                    customerId: this.customerId,
                    customerType: this.customerType,
                    payment_method: method,
                }
                CustomerAPIService.saveStripeBillingPaymentMethod(data, this.access_token)
                    .then((response) => {
                        this.loadPaymentMethods();
                    }).catch((error) => {
                        this.notify("Error Exception!",error, "error");
                    });

            },
            /*
                Loads all of the payment methods for the
                user.
            */
            loadPaymentMethods(){
                // need to call setup intent again for another card to save in stripe as stripe does not allow same intent to save new card.
                CustomerAPIService.getStripeBillingPaymentMethods(this.customerId, this.customerType, this.access_token)
                    .then((response) => {
                        this.paymentMethods = response.data;
                        this.paymentMethodsLoadStatus = 2;
                        for (const method of this.paymentMethods){
                            if( this.paymentMethods.length == 1 && method.type == 'bank_account' ){
                               this.isBankAccount = true;
                            }
                        }
                    }).catch((error) => {
                        this.notify("Error Exception!",error, "error");
                });
            },

            removePaymentMethod( paymentId ){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, remove it!'
                }).then((result) => {
                    if (result.value) {
                        let data = {
                            customerId: this.customerId,
                            customerType: this.customerType,
                            id: paymentId,
                        }
                        this.$store.commit('SHOW_LOADER',true);
                        CustomerAPIService.removeStripeBillingPaymentMethod(data, this.access_token)
                            .then((response) => {
                                this.loadPaymentMethods();
                                this.$store.commit('SHOW_LOADER',false);
                                swal.fire("Success!", "Stripe card removed successfully.", "success");
                            }).catch((error) => {
                            this.$store.commit('SHOW_LOADER',false); 
                            swal.fire("Error Exception!",error, "error");
                        });
                    }
                });

            },
            getAccountDetail: function(e){
                UserAPIService.getAccountDetail(this.access_token).then((response) => {
                    if(response.data.account_type == 'owner' || response.data.account_type == 'staff' || response.data.account_type == 'contact-person' || response.data.account_type == 'primary' || response.data.account_type == 'secondary' || response.data.account_type == 'admin')
                    {
                        this.name = response.data.settings.companyName; 
                        this.email = response.data.settings.customerEmail;
                    }
                });
            },
            validateInput: function(){
                let inputValue = document.querySelector("#card-element > div > input");
                let btnSubmit = document.getElementById("add-card-button");
                if (inputValue.value == "") {
                    btnSubmit.disabled = true;
                } else {
                    btnSubmit.disabled = false;
                }
            },
        }
    }
</script>
<style scoped>
    #card-element{
        border: 1px solid #EBEDF3;
        padding: 5px;
    }
</style>
